import useLicenseCheck from "license/useLicenseCheck";
import usePermissions from "hooks/usePermissions";
const useSecurityEventExecuteNotificationsCondition = () => {
  const { security } = useLicenseCheck();
  const { isPermitted } = usePermissions();
  return (security == null ? void 0 : security.isValid) && isPermitted("security_event:execute_notifications");
};
export default useSecurityEventExecuteNotificationsCondition;
